import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function cancelGroupSession(timeslotId: string | number) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/group_timeslot_orchid_pro/cancels_groupsession?group_timeslot_id=${timeslotId}`,
    {
      method: "POST",
    },
  );

  if (!res.ok) {
    throw new Error(
      `failed to cancel group session: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
